import React, { useMemo } from "react";
import { Button } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import { AiTwotoneEdit, AiFillDelete } from "react-icons/ai";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

const formatTimeSlot = (timeSlot) => {
  if (!timeSlot) return "";
  const trimmed = timeSlot.trim();
  if (/^\d{2}:\d{2}:\d{2}$/.test(trimmed)) {
    return trimmed.substring(0, 5);
  }
  return trimmed;
};

const mapApiLabel = (apiId) => {
  switch (Number(apiId || 0)) {
    case 1:
      return "Burj Khalifa";
    case 2:
      return "Museum Of The Future";
    default:
      return "";
  }
};

const TimeSlotPriceTable = ({ data, onEdit, onDelete }) => {
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Time Slot",
        field: "timeSlot",
        valueFormatter: (params) => formatTimeSlot(params.value),
      },
      {
        headerName: "API",
        field: "apiId",
        valueFormatter: (params) => mapApiLabel(params.value),
      },
      {
        headerName: "Prime Time",
        field: "primeTime",
        valueFormatter: (params) => (params.value ? "Yes" : "No"),
      },
      { headerName: "Ticket Type", field: "ticketTypeName" },
      { headerName: "Attraction", field: "attractionName" },
      { headerName: "Attraction Group", field: "attractionGroupName" },
      {
        headerName: "Action",
        filter: false,
        sortable: false,
        cellRendererFramework: (params) => (
          <div>
            <Button
              color="primary"
              size="sm"
              onClick={() => onEdit && onEdit(params.data)}
              className="mr-2"
            >
              <AiTwotoneEdit />
            </Button>
            <Button
              color="danger"
              size="sm"
              onClick={() => onDelete && onDelete(params.data)}
            >
              <AiFillDelete />
            </Button>
          </div>
        ),
      },
    ],
    [onEdit, onDelete]
  );

  const defaultColDef = {
    sortable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
    resizable: true,
  };

  return (
    <div className="ag-theme-alpine mt-3" style={{ height: "500px" }}>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={data}
        defaultColDef={defaultColDef}
        pagination
      />
    </div>
  );
};

export default TimeSlotPriceTable;

